import type { CampaignCreative } from "../types/campaign-card.type";

const CREATIVE_TYPE_ORDER: Record<string, number> = {
	HEADLINE: 0,
	DESCRIPTION: 1,
	TEXT: 2,
	IMAGE: 3,
	VIDEO: 4,
	YOUTUBE_VIDEO: 5,
	YOUTUBE: 6,
	HTML5: 7,
};

function typeRank(type: string): number {
	return CREATIVE_TYPE_ORDER[type.toUpperCase()] ?? 99;
}

/** Stable display order: type → ad_id → id → content. */
export function sortCreatives(
	creatives: CampaignCreative[],
): CampaignCreative[] {
	return [...creatives].sort((a, b) => {
		const byType = typeRank(a.type) - typeRank(b.type);
		if (byType !== 0) return byType;

		const byAdId = (a.adId ?? 0) - (b.adId ?? 0);
		if (byAdId !== 0) return byAdId;

		const byId = (a.id ?? 0) - (b.id ?? 0);
		if (byId !== 0) return byId;

		return a.content.localeCompare(b.content);
	});
}
